"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ViewCube_1 = __importDefault(require("./ViewCube"));
exports.default = ViewCube_1.default;
